<template>
  <div class="notFound">
    404 NOT FOUND
  </div>
</template>

<script>
export default {
  data() {
    return {};
  }
};
</script>

<style scoped></style>
